import { Component, default as React } from "react";
import ContentLoader from "react-content-loader";

class VehiclesBanner extends Component {
  render() {
    return (
      <React.Fragment>
        <ContentLoader
          viewBox="0 0 380 70"
          speed={5}
          backgroundColor={"lightgrey"}
          foregroundColor={"#d9ffe3"}
        >
          {/* Only SVG shapes */}
          <rect x="0" y="30" rx="5" ry="5" width="61" height="41" />
          <rect x="80" y="37" rx="4" ry="4" width="200" height="13" />
          <rect x="80" y="60" rx="3" ry="3" width="280" height="10" />
        </ContentLoader>
      </React.Fragment>
    );
  }
}

export default VehiclesBanner;
